// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gj-0";
export var actionModalContentContainer = "_gj-1";
export var createTagButton = "_gj-2";
export var footerContainer = "_gj-7";
export var fullWidthDivider = "_gj-3";
export var hasCreateTagButton = "_gj-4";
export var noCreateTagButton = "_gj-5";
export var tagsContainer = "_gj-6";
export var tagsModalContentContainer = "_gj-8";